import { ref, computed } from "@vue/composition-api";
import store from "@/store";

export default function useVerticalNavMenu(props) {
    // ------------------------------------------------
    // isVerticalMenuCollapsed
    // ------------------------------------------------
    const isVerticalMenuCollapsed = computed({
        get: () => store.state.verticalMenu.isVerticalMenuCollapsed,
        set: (val) => {
            store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", val);
        },
    });

    const isRightMenuCollapsed = computed({
        get: () => store.state.verticalMenu.isRightMenuCollapsed,
        set: (val) => {
            store.commit("verticalMenu/UPDATE_RIGHT_MENU_COLLAPSED", val);
        },
    });

    // ------------------------------------------------
    // collapseTogglerIcon
    // ------------------------------------------------
    const collapseTogglerIcon = computed(() => {
        if (props.isVerticalMenuActive) {
            return isVerticalMenuCollapsed.value ? "unpinned" : "pinned";
        }
        return "close";
    });

    const isMouseHovered = ref(false);

    const updateMouseHovered = (val) => {
        isMouseHovered.value = val;
    };

    const toggleCollapsed = () => {
        isVerticalMenuCollapsed.value = !isVerticalMenuCollapsed.value;
    };

    const setCollapsed = (value) => {
        isVerticalMenuCollapsed.value = value;
    };

    const setRightCollapsed = (value) => {
        isRightMenuCollapsed.value = value;
    };

    return {
        isMouseHovered,
        isVerticalMenuCollapsed,
        collapseTogglerIcon,
        toggleCollapsed,
        updateMouseHovered,
        setCollapsed,
        setRightCollapsed,
        isRightMenuCollapsed
    };
}
